import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../Global/axios";
import { sortByName } from "../../utils/sortByName";

const getNationlityData = createAsyncThunk("api/nationality", async (token) => {
  try {
    const response = await axios.get("/dashboard/nationality", {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data.data;
  } catch (e) {
    throw new Error(e.message);
  }
});

const NationalityDataSlice = createSlice({
  name: "Nationality",
  initialState: {
    data: null,
    error: "",
    status: false,
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getNationlityData.fulfilled, (state, action) => {
        state.data = sortByName(action.payload);
        state.isLoading = false;
        state.status = true;
      })
      .addCase(getNationlityData.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getNationlityData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export { getNationlityData };
export default NationalityDataSlice.reducer;
